import { createContext, useContext, useState, useEffect, useCallback } from "react";

const LearningAuthContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export function LearningAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("learning_token"));
  const [loading, setLoading] = useState(true);

  const authHeaders = useCallback(() => {
    const t = token || localStorage.getItem("learning_token");
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, [token]);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(`${API}/api/learning/auth/me`, { headers: authHeaders() })
      .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
      .then(setUser)
      .catch(() => { localStorage.removeItem("learning_token"); setToken(null); setUser(null); })
      .finally(() => setLoading(false));
  }, [token, authHeaders]);

  const login = async (email, password) => {
    const r = await fetch(`${API}/api/learning/auth/login`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if (!r.ok) {
      let msg = "Login failed";
      try { const d = await r.json(); msg = d.detail || msg; } catch {}
      throw new Error(msg);
    }
    const d = await r.json();
    localStorage.setItem("learning_token", d.access_token);
    setToken(d.access_token);
    setUser(d.user);
    return d.user;
  };

  const register = async (data) => {
    const r = await fetch(`${API}/api/learning/auth/register`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!r.ok) {
      let msg = "Registration failed";
      try { const d = await r.json(); msg = d.detail || msg; } catch {}
      throw new Error(msg);
    }
    const d = await r.json();
    localStorage.setItem("learning_token", d.access_token);
    setToken(d.access_token);
    setUser(d.user);
    return d.user;
  };

  const logout = () => {
    localStorage.removeItem("learning_token");
    setToken(null);
    setUser(null);
  };

  return (
    <LearningAuthContext.Provider value={{ user, token, loading, login, register, logout, authHeaders, isAuthenticated: !!user }}>
      {children}
    </LearningAuthContext.Provider>
  );
}

export const useLearningAuth = () => useContext(LearningAuthContext);
